import type {ElementType, ReactNode} from 'react';

import {twx} from '@/utils/tailwindUtils';

type AutoDeliveryDcxStatusTitleProps = {
    className?: string;
    title?: ReactNode;
    renderAs?: ElementType;
};

const AutoDeliveryDcxStatusTitle = ({className, title, renderAs: Heading = 'h1'}: AutoDeliveryDcxStatusTitleProps) => {
    return (
        <Heading className={twx('text-20 font-bold leading-143 tracking-02 md:text-18 md:leading-[24px]', className)}>
            {title}
        </Heading>
    );
};

export default AutoDeliveryDcxStatusTitle;
